import { FilterPickerConsumerProps } from './FilterPickerDynamicConsumer';
import { useContactsContext } from '../../../modules/contacts/hooks/useContactsProvider';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { apiFetchSearch } from '../../../modules/dashboard/api';
import { ProjectMember, ProjectMemberCalculatedData } from '../../../models/ProjectContacts';

const ProjectMemberFilterPickerConsumer: React.FC<FilterPickerConsumerProps> = (
  props
) => {
  //#region ------------------------------ Defaults
  const { children } = props;
  const { getContactById } = useContactsContext();
  const { projectId } = useParams<{ projectId: string }>();
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  //#endregion

  //#region ------------------------------ Methods / Handlers
  const { data: projectMembersData } = useQuery({
    queryKey: ['projectMembers', projectId],
    queryFn: () =>
      apiFetchSearch(
        'projectMembers',
        `ProjectId eq '${projectId}'`,
        1000,
        false
      ),
  });
  //#endregion

  //#region ------------------------------ Render
  return (
    <>
      {children({
        options: (projectMembersData?.data?.items ?? [])
          .filter((member) => !(member.data as ProjectMember & ProjectMemberCalculatedData)?.isArchived)
          .sort((a, b) => {
            const contactA = getContactById((a.data as ProjectMember & ProjectMemberCalculatedData).contactId);
            const contactB = getContactById((b.data as ProjectMember & ProjectMemberCalculatedData).contactId);

            if (!contactA && !contactB) return 0;
            if (!contactA) return 1;
            if (!contactB) return -1;

            return (
              contactA.lastName.localeCompare(contactB.lastName) ||
              contactA.firstName.localeCompare(contactB.firstName)
            );
          })
          .map((item, index) => {
            const { contactId } = item.data as ProjectMember & ProjectMemberCalculatedData;
            const contact = getContactById(contactId);
            const firstName = contact?.firstName ?? '';
            const lastName = contact?.lastName ?? '';
            return {
              key: index,
              value: contactId,
              label: `${firstName} ${lastName}`,
              searchValue: `${firstName} ${lastName} ${contactId}`,
            };
          }),
      })}
    </>
  );
};

export default ProjectMemberFilterPickerConsumer;
